import { productServices } from '../services';
import { productConstants } from '../constants/product.constants';

const table = body => {
    return async dispatch => {
        return productServices.table(body).then(
            table => {
                return table;
            },
            error => {
                return error;
            }
        );
    };
};

const create = body => {
    const request = () => ({
        type: productConstants.PRODUCT_CREATE_REQUEST
    });

    const success = () => ({
        type: productConstants.PRODUCT_CREATE_SUCCESS
    });

    const failure = () => ({
        type: productConstants.PRODUCT_CREATE_FAILURE
    });

    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        productServices.create(body).then(
            product => {
                dispatch(success());

                resolve(product);
            },
            errors => {
                dispatch(failure());

                reject(errors);
            }
        );
    });
};

const edit = (id, body) => {
    const request = () => ({
        type: productConstants.PRODUCT_EDIT_REQUEST
    });

    const success = () => ({
        type: productConstants.PRODUCT_EDIT_SUCCESS
    });

    const failure = () => ({
        type: productConstants.PRODUCT_EDIT_FAILURE
    });

    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        productServices.edit(id, body).then(
            product => {
                dispatch(success());

                resolve(product);
            },
            errors => {
                dispatch(failure());

                reject(errors);
            }
        );
    });
};

const find = id => {
    const request = () => ({
        type: productConstants.PRODUCT_FIND_REQUEST
    });

    const success = () => ({
        type: productConstants.PRODUCT_FIND_SUCCESS
    });

    const failure = () => ({
        type: productConstants.PRODUCT_FIND_FAILURE
    });

    return async dispatch => {
        dispatch(request());

        return productServices.find(id).then(
            product => {
                dispatch(success());

                return product;
            },
            error => {
                dispatch(failure());

                return error;
            }
        );
    };
};

const remove = id => {
    const request = () => ({
        type: productConstants.PRODUCT_REMOVE_REQUEST
    });

    const success = () => ({
        type: productConstants.PRODUCT_REMOVE_SUCCESS
    });

    const failure = () => ({
        type: productConstants.PRODUCT_REMOVE_FAILURE
    });

    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        productServices.remove(id).then(
            () => {
                dispatch(success());

                resolve();
            },
            errors => {
                dispatch(failure());

                reject(errors);
            }
        );
    });
};

export const productActions = {
    table,
    create,
    edit,
    find,
    remove
};
